import { getData, postData } from './apiService'

// Unified API client for handling generic GET and POST requests
const apiClient = {
  // Function for making POST requests with version prefix
  postRequest: async (path, data, apiType, customHeaders = {}) => {
    const endpoint = `${path}` // Prefix the path with the version
    return await postData(endpoint, data, customHeaders)
  },

  // Function for making GET requests with version prefix
  getRequest: async (path, apiType, customHeaders = {}) => {
    const endpoint = `${path}` // Prefix the path with the version
    return await getData(endpoint, customHeaders)
  },
}

export default apiClient
